import { Component, OnInit, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { McommerceVirtualCashRegisterCheckOutValidatePaymentTypeDialogComponent } from 'src/app/components/mcommerce-components/mcommerce-virtual-cash-register-check-out-validate-payment-type-dialog/mcommerce-virtual-cash-register-check-out-validate-payment-type-dialog.component';

@Component({
  selector: 'app-mcommerce-virtual-cash-register-check-out-user-detail-card',
  templateUrl: './mcommerce-virtual-cash-register-check-out-user-detail-card.component.html',
  styleUrls: ['./mcommerce-virtual-cash-register-check-out-user-detail-card.component.scss']
})
export class McommerceVirtualCashRegisterCheckOutUserDetailCardComponent implements OnInit {

  @Input() cartInfo;

  constructor(public dialog: MatDialog) { }

  ngOnInit() { }

  public validatePurchase() {
    this.dialog.open(McommerceVirtualCashRegisterCheckOutValidatePaymentTypeDialogComponent);
  }

}
